import { formatAuditEventType, formatAuditActor } from "./employeeAuditFormat";

export interface EmployeeLifecycleSnapshot {
  latestLifecycleReason?: string | null;
  latestLifecycleEventType?: string | null;
  latestLifecycleAt?: string | null;
  latestLifecycleBy?: string | null;
  latestLifecycleByName?: string | null;
  latestLifecycleByEmail?: string | null;
  suspensionReason?: string | null;
}

export function resolveLifecycleReason(
  employee: EmployeeLifecycleSnapshot,
): string | null {
  const lifecycleReason = employee.latestLifecycleReason?.trim();
  if (lifecycleReason) return lifecycleReason;

  const suspensionReason = employee.suspensionReason?.trim();
  if (suspensionReason) return suspensionReason;

  return null;
}

export function hasEmployeeLifecycleDetail(employee: EmployeeLifecycleSnapshot): boolean {
  return Boolean(
    resolveLifecycleReason(employee) ||
      employee.latestLifecycleEventType ||
      employee.latestLifecycleAt,
  );
}

export function formatLifecycleEventType(eventType: string | null | undefined): string {
  return formatAuditEventType(eventType);
}

export function formatLifecycleActor(employee: EmployeeLifecycleSnapshot): string {
  return formatAuditActor({
    actorName: employee.latestLifecycleByName,
    actorEmail: employee.latestLifecycleByEmail,
    actorSub: employee.latestLifecycleBy,
  });
}

export function formatLifecycleTimestamp(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}
